import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "customer__container" }
const _hoisted_2 = {
  key: 0,
  class: "spinner"
}
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { class: "wrapper-customer-lots" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "customer__title" }, "My Lots", -1)),
    ($setup.showSpinner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (!$setup.lots.length && !$setup.showSpinner)
      ? (_openBlock(), _createBlock($setup["CustomerDetailsCardEmpty"], {
          key: 1,
          class: "empty-card",
          "img-path": "assets/icons/icon-customer-lots.svg",
          message: "You have no active lots yet"
        }))
      : _createCommentVNode("", true),
    ($setup.lots.length && !$setup.showSpinner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "customer__sub-title" }, "Active Lots", -1)),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lots, (item, index) => {
              return (_openBlock(), _createBlock($setup["CustomerDetailsCardLots"], {
                class: "customer-lot",
                data: item,
                key: index,
                onClick: ($event: any) => ($setup.onLot(item))
              }, null, 8, ["data", "onClick"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}